import { ChaCard } from "../CharCard";
import { CharactersSection } from "./styles";

export const Characters = ({ characterList }) => {
  return (
    <div>
      <CharactersSection>
        {characterList.map(
          ({ name, image, status, origin, species, id, location }) => (
            <ChaCard
              key={id}
              name={name}
              image={image}
              status={status}
              origin={origin.name}
              species={species}
              location={location.name}
            />
          )
        )}
      </CharactersSection>
    </div>
  );
};
